import { createFileRoute } from '@tanstack/react-router';
import { QuickQuoteTerms } from '../../components/QuickQuoteTerms';

export const Route = createFileRoute('/quickquote/privacy')({
  component: QuickQuoteTerms,
});
